import { api } from './../../api.js';

import axios from 'axios';

const state = {
	
}

const getters = {
	
}

const mutations = {
	
}

const actions = {
  getModules: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      var params = {
        filters: {
          ...data.filters,
          exclude : ['lessons_modules', 'lessons_has_tincan', 'lessons_tincan_operations', 'lessons_miscellanous_info', 'lessons_tags'],
          per_page : 5,
        }
      };

      api
        .get("admin/modules", params)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  getModule: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/modules/" + data.id, data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  createModule: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/modules", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  editModule: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .patch("admin/modules/" + data.id, data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  editModuleCategory: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/modules/" + data.id + "/add-category", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getModuleLessons: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/modules/" + data.id + "/lessons", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  addLessonToModule: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/modules/" + data.id + "/add-lesson", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  updateModuleImage: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/modules/" + data.id + "/update-img", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  deleteLessonCourse: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .delete(
          "admin/modules/" + data.id + "/delete-lesson/" + data.lesson_id,
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  changeLessonOrder: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post(
          "admin/modules/" + data.id + "/change-lesson-order/" + data.lesson_id,
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  pairModuleQuiz: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/modules/" + data.id + "/create-quiz/", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  pairModuleNonQuiz: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/modules/" + data.id + "/create-base/", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeLanguageFromModule: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post(
          "admin/modules/" + data.id + "/delete-language/" + data.language,
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addLanguageToModule: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post(
          "admin/modules/" + data.id + "/add-language/" + data.language,
          data
        )
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  async getModuleSecondaryNames({ commit }, data) {
    try {
      const params = {
        filters: {
          module_id: data.moduleId,
        },
      };

      const response = await api.get(`admin/module-secondary-names`, params);

      return response.data.data.reduce((acc, secondaryName) => {
        if (secondaryName.name) {
          acc.push(secondaryName);
        }
        return acc;
      }, []);
    } catch (error) {
      console.log('error getModuleSecondaryNames', error);
      throw error;
    }
  },

  async setModuleSecondaryNames({ commit }, data) {
    try {
      const params = {
        filters: {},
        ...data,
      };

      const response = await api.patch(`admin/modules/${data.moduleId}/secondary-names`, params);

      return response;
    } catch (error) {
      console.log('error setModuleSecondaryNames', error);
      throw error;
    }
  },

  async addCeuTimeState({ commit }, data) {
    try {
      const params = {
        filters: {},
        ...data,
      };

      const response = await api.post(`admin/modules/${data.module_id}/module-ceu`, params);

      return response;
    } catch (error) {
      console.log('error addCeuTimeState', error);
      throw error;
    }
  },

  async updateCeuTimeState({ commit }, data) {
    try {
      const params = {
        filters: {},
        ...data,
      };

      const response = await api.patch(`admin/modules/${data.module_id}/module-ceu/${data.id}`, params);

      return response;
    } catch (error) {
      console.log('error addCeuTimeState', error);
      throw error;
    }
  },

  async removeCeuTimeState({ commit }, data) {
    try {
      const params = {
        filters: {},
        data: {
          id: data.id,
        },
      };

      const response = await api.delete(`admin/modules/${data.module_id}/module-ceu/${data.id}`, params);

      return response;
    } catch (error) {
      console.log('error addCeuTimeState', error);
      throw error;
    }
  },

  async addAssocReqState({ commit }, data) {
    try {
      const params = {
        filters: {},
        ...data,
      };

      const response = await api.post(`admin/modules/${data.module_id}/module-assoc-req`, params);

      return response;
    } catch (error) {
      console.log('error addAssocReqState', error);
      throw error;
    }
  },

  async updateAssocReqState({ commit }, data) {
    try {
      const params = {
        filters: {},
        ...data,
      };

      const response = await api.patch(`admin/modules/${data.module_id}/module-assoc-req/${data.id}`, params);

      return response;
    } catch (error) {
      console.log('error updateAssocReqState', error);
      throw error;
    }
  },

  async removeAssocReqState({ commit }, data) {
    try {
      const params = {
        filters: {},
        data: {
          id: data.id,
        },
      };

      const response = await api.delete(`admin/modules/${data.module_id}/module-assoc-req/${data.id}`, params);

      return response;
    } catch (error) {
      console.log('error removeAssocReqState', error);
      throw error;
    }
  },
};

export default {
	state, 
	actions,
	getters,
	mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/ModuleModule.js